import type { ReactNode } from 'react';
import { Check, Copy } from 'lucide-react';
import { COPY_BY_HAND, useCopy } from './use-copy';

export interface CopyButtonProps {
  /** What lands on the clipboard. */
  value: string;
  /** What the button copies, for the screen reader ("Copy the email address"). */
  label: string;
  /** After the value is on the clipboard (product analytics; never passed the value). */
  onCopied?: () => void;
}

/** One click copies; the button says Copied for a moment, or that it could not and what to do. */
export function CopyButton({ value, label, onCopied }: CopyButtonProps): ReactNode {
  const { state, copy } = useCopy(
    value,
    onCopied ? { resetMs: 1800, onCopied } : { resetMs: 1800 },
  );
  const copied = state === 'copied';
  return (
    <>
      <button
        type="button"
        className={`intake-copy${copied ? ' is-copied' : ''}`}
        onClick={() => void copy()}
        aria-label={label}
      >
        {copied ? <Check size={14} aria-hidden="true" /> : <Copy size={14} aria-hidden="true" />}
        {copied ? 'Copied' : 'Copy'}
      </button>
      <span className="intake-copy__said" role="status">
        {state === 'failed' ? COPY_BY_HAND : ''}
      </span>
    </>
  );
}
